import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { getAllPoems } from '../../services/poemService';
import bg1 from '../../assets/images/b2.png'


export default class Poems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            poems: getAllPoems()
        };
    }

    componentDidMount() {

    }

    render() {
        return (
            <div>
                <div className="pageHeader" style={{ backgroundImage: `url(${bg1})` }}>
                    <h1>Poems</h1>
                </div>
                {this.state.poems.map((poem) => {
                    return <div className="poems">
                        <span>{poem.poemTitle}</span> by <span>{poem.poetName}</span> - {poem.locationName}
                    </div>
                })}

            </div>
        );
    }
}
